/**
 * Les buts à afficher pour un joueur
 * Un buteur ayant marqué et marqué contre son camp est affiché dans les 2 équipes :
 * seuls ses buts réels sont affichés dans son équipe, seuls ses CSC dans l'équipe adverse
 */
export const ALL_GOALS = "allGoals";
export const SCORED_GOALS_ONLY = "scoredGoalsOnly";
export const OWN_GOALS_ONLY = "ownGoalsOnly";